<template>
  <div class="xselect">
    <el-select
    :clearable='clearable'
      v-scroll-bottom="loadmore"
      style="width:100%"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <el-empty description="暂无数据" :slot="'empty'"></el-empty>
      <el-option
        v-for="(item, index) in nodeData"
        :key="index"
        :label="item[label] ? item[label] : item"
        :value="item[model] ? item[model] : item"
      >
      </el-option>
      <div
        class="loadingbox"
        v-if="loading"
        element-loading-text="加载中.."
        v-loading="loading"
      ></div>
    </el-select>
  </div>
</template>
<script>
export default {
  props: {
    clearable:{
      type:Boolean,
      default:true,
    },
    axiosType: Boolean, //接口类型
    params: Object, //查询参数
    url: String, //接口地址
    queryNow: {
      //是否立即进行查询
      type: Boolean,
      default: true,
    },
    isopen: {
      //是否打开分页查询  false为开启分页
      type: Boolean,
      default: false,
    },
    label: {
      //绑定的名称
      type: String,
    },
    model: {
      //绑定的值
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      nodeData: [],
      current: 1,
      stopSearch: this.isopen,
      isDataemty: false,
    };
  },
  mounted() {
  },
  methods: {
    /* 重置node数据 */
    setnodeData() {
      this.nodeData = [];
    },
    loadmore() {
      if (!this.isDataemty && !this.stopSearch) {
        this.search();
      }
    },

    init() {
      if (this.queryNow) {
        this.search();
      }
    },
    resetNode() {
      this.current = 1;
      this.loading = true;
      if (this.axiosType) {
        this.$requestAxiosForm(
          {
            url: this.url,
            data: Object.assign(
              { current: this.current, size: 20 },
              this.params
            ),
          },
          (data) => {
            this.nodeData = data.data;
            setTimeout(() => {
              this.loading = false;
            }, 500);
            setTimeout(() => {
              this.isDataemty = false;
            }, 1000);

            if (
              data.data.length !== 20 &&
              this.current !== 1 &&
              !this.stopSearch
            ) {
              this.stopSearch = true;
            }
          },
          () => {
            setTimeout(() => {
              this.loading = false;
              this.isDataemty = false;
            }, 500);
          }
        );
      } else {
        this.$requestAxios(
          {
            url: this.url,
            data: Object.assign(
              { current: this.current, size: 20 },
              this.params
            ),
          },
          (data) => {
            this.current = this.current + 1;

            if (
              data.data.length !== 20 &&
              this.current !== 1 &&
              !this.stopSearch
            ) {
              this.stopSearch = true;
            }
            setTimeout(() => {
              this.loading = false;
            }, 500);
            setTimeout(() => {
              this.isDataemty = false;
            }, 1000);
            this.nodeData = data.data;
          },
          () => {
            setTimeout(() => {
              this.loading = false;
              this.isDataemty = false;
            }, 500);
          }
        );
      }
    },
    search() {
      this.loading = true;
      this.isDataemty = true;
      if (this.axiosType) {
        this.$requestAxiosForm(
          {
            url: this.url,
            data: Object.assign(
              { current: this.current, size: 20 },
              this.params
            ),
          },
          (data) => {
            this.current = this.current + 1;
            this.nodeData = this.nodeData.concat(data.data);
            setTimeout(() => {
              this.loading = false;
            }, 500);
            setTimeout(() => {
              this.isDataemty = false;
            }, 1000);

            if (
              data.data.length !== 20 &&
              this.current !== 1 &&
              !this.stopSearch
            ) {
              this.stopSearch = true;
            }
          },
          () => {
            setTimeout(() => {
              this.loading = false;
              this.isDataemty = false;
            }, 500);
          }
        );
      } else {
        this.$requestAxios(
          {
            url: this.url,
            data: Object.assign(
              { current: this.current, size: 20 },
              this.params
            ),
          },
          (data) => {
            this.current = this.current + 1;

            if (
              data.data.length !== 20 &&
              this.current !== 1 &&
              !this.stopSearch
            ) {
              this.stopSearch = true;
            }
            setTimeout(() => {
              this.loading = false;
            }, 500);
            setTimeout(() => {
              this.isDataemty = false;
            }, 1000);
            this.nodeData = this.nodeData.concat(data.data);
          },
          () => {
            setTimeout(() => {
              this.loading = false;
              this.isDataemty = false;
            }, 500);
          }
        );
      }
    },
  },
};
</script>
<style scoped>
.xselect {
  position: relative;
}
.loadingbox {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}
</style>
